import { TableBasicData } from "#competence/components/table/TableBasicData"
import { Box, Button, Grid, TextField } from "@mui/material"
import { useState } from "react"
import { toast } from "react-toastify"

const defaultValues = {
	company: "",
	activities_performed: "",
	reason_for_leaving: "",
	employment_duration: "",
}

export default function EvaluationWorkHistories({ values = [], setValues }) {
	const [work, setWork] = useState(defaultValues)

	const items = [
		{
			label: "Nombre de Empresa",
			name: "company",
			grid: { xs: 12, sm: 6 },
		},
		{
			label: "Tiempo Laboral",
			name: "employment_duration",
			grid: { xs: 12, sm: 6 },
		},
		{
			label: "Actividades Desarrolladas	",
			name: "activities_performed",
			grid: { xs: 12 },
		},
		{
			label: "Motivo de Salida",
			name: "reason_for_leaving",
			grid: { xs: 12 },
		},
	]

	const handleSave = () => {
		if (values.map((item) => item.company).includes(work["company"])) {
			toast.error(`Ya existe un historial con la empresa '${work["company"]}'`)
			return
		}
		for (const index in items) {
			const key = items[index].name

			if (!work?.[key]?.trim()) {
				toast.error("El campo '" + items[index].label + "' es requerido")
				return
			}
		}

		setValues((values) => [...values, work])
		setWork(defaultValues)
	}

	const itemForm = items.map((item) => {
		const handleChange = (e) => {
			setWork((work) => ({
				...work,
				[item.name]: e.target.value,
			}))
		}
		return (
			<Grid item key={item.name} {...item.grid}>
				<TextField
					label={item.label}
					onChange={handleChange}
					value={work[item.name] || ""}
					fullWidth
				/>
			</Grid>
		)
	})

	return (
		<Box sx={{ textAlign: "center", p: 2 }}>
			<Grid container spacing={2} sx={{ mb: 4 }}>
				{itemForm}
				<Grid item xs={12}>
					<Button variant="contained" color="primary" onClick={handleSave}>
						Agregar Historial
					</Button>
				</Grid>
				<Grid item xs={12}>
					<TableBasicData items={items} data={values} />
				</Grid>
			</Grid>
		</Box>
	)
}
